import { createSelector } from 'reselect';

const getCurrentUser = state => state.currentUser.data;

export const isSuperAdmin = createSelector(
  [getCurrentUser],
  currentUser =>
    currentUser
      ? currentUser.roles
          .map(role => role.name.toLowerCase().trim())
          .includes('super admin')
      : false,
);

export const isAdministrativeProvider = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('administrative provider')
      : false,
);

export const isSupervisingPhysician = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
          .map(role => role.name.toLowerCase().trim())
          .includes('supervising physician')
      : false,
);

export const isAdmin = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
          .map(role => role.name.toLowerCase().trim())
          .includes('admin')
      : false,
);

export const isExecutive = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('executive')
      : false,
);

export const isClinician = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
          .map(role => role.name.toLowerCase().trim())
          .includes('clinician')
      : false,
);

export const isClinicalStaff = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('clinical staff')
      : false,
);

export const isPhysiciansAssistant = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('physicians assistant')
      : false,
);

export const isClinicalPharmacist = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('clinical pharmacist')
      : false,
);

export const isManager = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
          .map(role => role.name.toLowerCase().trim())
          .includes('manager')
      : false,
);

export const isStaff = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
          .map(role => role.name.toLowerCase().trim())
          .includes('staff')
      : false,
);

export const isExternalStakeholder = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
          .map(role => role.name.toLowerCase().trim())
          .includes('external stakeholder')
      : false,
);

export const isOrganizationalClient = createSelector(
  getCurrentUser,
  currentUser =>
    currentUser
      ? currentUser.roles
          .map(role => role.name.toLowerCase().trim())
          .includes('organizational client')
      : false,
);

export const isPatientAdvocate = createSelector(
  [getCurrentUser],
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('patient advocate')
      : false,
);

export const isClinicalComplianceManager = createSelector(
  [getCurrentUser],
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('clinical compliance manager')
      : false,
);

export const isClinicalOperationsManager = createSelector(
  [getCurrentUser],
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('clinical operations manager')
      : false,
);

export const isCareNavigator = createSelector(
  [getCurrentUser],
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('care navigator')
      : false,
);

export const isMakoAdmin = createSelector(
  [getCurrentUser],
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('mako admin')
      : false,
);

export const isMakoUser = createSelector(
  [getCurrentUser],
  currentUser =>
    currentUser
      ? currentUser.roles
        .map(role => role.name.toLowerCase().trim())
        .includes('mako user')
      : false,
);



// WEBPACK FOOTER //
// ./src/store/current-user/CurrentUserSelectors.js